import { render, staticRenderFns } from "./ManageSidemenuLayout.vue?vue&type=template&id=eabf03de&scoped=true&lang=pug&"
import script from "./ManageSidemenuLayout.vue?vue&type=script&lang=ts&"
export * from "./ManageSidemenuLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabf03de",
  null
  
)

export default component.exports